import type { Params } from '@angular/router';
import type { Observable, Subscription } from 'rxjs';
import { auditTime, combineLatest, distinctUntilChanged, of, pluck, switchMap } from 'rxjs';

export interface PushPageView {
  pushPageView(url: string, payload?: Record<string, any>): void;
}

export function checkCasinoPageAnalytics(
  url$: Observable<string>, // activatedUrl.url
  params$: Observable<Params>,
  analyticsService: PushPageView
): Subscription {
  function checkAnalytics() {
    return ([url, gameSlug]: [string, string | undefined]): void => {
      checkAnalyticsRouteParams(url, gameSlug);
    };
  }

  function checkAnalyticsRouteParams(url: string, gameSlug: string | undefined): void {
    // biome-ignore lint/style/useNamingConvention: that's what SEO expects
    const viewInfo: Record<string, Record<string, string | undefined>> = { view_info: { gameSlug } };

    analyticsService.pushPageView(url, viewInfo);
  }

  function getGameSlugName(): Observable<string | undefined> {
    return params$.pipe(pluck('slugName'), distinctUntilChanged());
  }

  return combineLatest([url$, getGameSlugName()]).pipe(auditTime(50)).subscribe(checkAnalytics());
}

export function checkSportsPageAnalytics(
  url$: Observable<string>,
  params$: Observable<Params>,
  analyticsService: PushPageView
): Subscription {
  function checkAnalytics() {
    return ([url, routeParams]: [string, Params]): void => {
      checkAnalyticsRouteParams(url, routeParams);
    };
  }

  function checkAnalyticsRouteParams(url: string, routeParams: Params): void {
    const container: Record<string, string | undefined> = {};

    const paramsToCheck: string[] = ['disciplineId', 'leagueId', 'regionId', 'matchId'];
    for (const paramName of paramsToCheck) {
      container[paramName] = undefined;
      if (routeParams[paramName]) {
        container[paramName] = isNaN(Number(routeParams[paramName]))
          ? routeParams[paramName]
          : Number(routeParams[paramName]);
      }
    }
    analyticsService.pushPageView(url, container);
  }
  return url$.pipe(switchMap((url: string) => combineLatest([of(url), params$]))).subscribe(checkAnalytics());
}
